import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { HttpClient } from '@angular/common/http';
import { FooterComponent } from './components/footer/footer.component';
import { Router, RoutesRecognized } from '@angular/router';
import { NavbarComponent } from './components/navbar/navbar.component';
import { CommonModule } from '@angular/common';
import { EditorModule } from 'primeng/editor';
import { ToastModule } from 'primeng/toast';
import { filter, map } from 'rxjs';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    FooterComponent,
    NavbarComponent,
    CommonModule,
    EditorModule,
    ToastModule,
  ],
  providers: [HttpClient],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'CRM_Frontend';

  // Verborgen starten: sonst baut die Navbar sich vor dem ersten Router-Ereignis auf und lädt
  // Benutzerdaten — auf dem öffentlichen Stundenplan ein 401 ohne Anmeldung.
  showNavbar = false;
  showFooter = false;

  constructor(
    private router: Router,
    private primengConfig: PrimeNGConfig,
  ) {
    primengConfig.ripple = true;
    this.setTranslations();

    this.router.events
      .pipe(
        // RoutesRecognized statt NavigationEnd: muss vor der Aktivierung feststehen. Deshalb auch
        // der Snapshot aus dem Ereignis — activatedRoute zeigt hier noch die alte Route.
        filter(
          (event): event is RoutesRecognized =>
            event instanceof RoutesRecognized,
        ),
        map((event) => {
          let route = event.state.root;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route.data;
        }),
      )
      .subscribe((data) => {
        this.showNavbar = data['showNavbar'] ?? true;
        this.showFooter = data['showFooter'] ?? true;
      });
  }

  setTranslations(): void {
    this.primengConfig.setTranslation({
      startsWith: 'Beginnt mit',
      contains: 'Enthält',
      notContains: 'Enthält nicht',
      endsWith: 'Endet mit',
      equals: 'Gleich',
      notEquals: 'Nicht gleich',
      noFilter: 'Kein Filter',
      accept: 'Annehmen',
      reject: 'Abbrechen',
      clear: 'Zurücksetzen',
      apply: 'Anwenden',
      monthNames: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
      ],
      monthNamesShort: [
        'Jan',
        'Feb',
        'Mär',
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez',
      ],
      // PrimeNG erwartet diese Arrays immer sonntagsbeginnend, unabhängig von firstDayOfWeek.
      dayNames: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag',
      ],
      dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      today: 'Heute',
      weekHeader: 'KW',
      firstDayOfWeek: 1,
      dateFormat: 'dd.mm.yy',
      prevMonth: 'Vorheriger Monat',
      nextMonth: 'Nächster Monat',
      prevYear: 'Vorheriges Jahr',
      nextYear: 'Nächstes Jahr',
      chooseMonth: 'Monat wählen',
      chooseYear: 'Jahr wählen',
      chooseDate: 'Datum wählen',
    });
  }

  // ngOnInit(): void {
  //   if (!this.authService.isLoggedIn()) {
  //     console.warn(
  //       'Der Benutzer ist nicht global eingeloggt. Weiterleitung zur Anmeldung.'
  //     );
  //     this.router.navigate(['/login']);
  //   }
  // }
}
